import Controller from '@ember/controller';
import { action } from '@ember/object';
import type MarketSettingsCostIndexRoute from 'lumen/routes/market/settings/cost/index';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsCostIndexController extends Controller {
  declare model: ModelFrom<MarketSettingsCostIndexRoute>;

  // TODO: gate on the real cost-settings edit-access flag once it exists.
  get isReadOnly(): boolean {
    return false;
  }

  @action async refreshProfiles(): Promise<void> {
    await this.model.profiles.perform();
  }
}
